import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientProfile } from '../patient.model';
import { MaterialModule } from '../../material.module';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  @Input() patient: PatientProfile = {} as PatientProfile;
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  authService = inject(AuthService);

  constructor() {}

  ngOnInit(): void {
  }

  onProfileManage() {
    this.router.navigate(['/dashboard/profile-manage']);
  }

  onSettings() {
    this.router.navigate(['/settings']);
  }

  onDocuments() {
    this.router.navigate(['/documents']);
  }

  onProfileLogout() {
    sessionStorage.removeItem('appState');
    sessionStorage.removeItem('patientId');
    this.authService.logout();
  }
}
